var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuBar = function SvgMenuBar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.373 6H6.293C5.03 6 4 6.747 4 7.667c0 .919 1.029 1.666 2.294 1.666h14.08c1.264 0 2.293-.747 2.293-1.666 0-.92-1.03-1.667-2.294-1.667",
    opacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.706 14.333h-14.08c-1.264 0-2.293.748-2.293 1.667s1.03 1.666 2.294 1.666h14.08C26.97 17.666 28 16.92 28 16c0-.92-1.029-1.667-2.294-1.667M20.373 22.667H6.293C5.03 22.667 4 23.414 4 24.334 4 25.253 5.029 26 6.294 26h14.08c1.264 0 2.293-.747 2.293-1.666 0-.92-1.03-1.667-2.294-1.667"
  })));
};
export default SvgMenuBar;